import { escapeHtml } from "./html";

type WriterFrameViewModel = {
  version: string;
  status: string;
  steps: string;
  helpCard: string;
  helpExpanded: boolean;
  showFileInput: boolean;
  returnSource: string | null;
};

/** Renders the static Writer frame around the dynamic status and action views. */
export function renderWriterFrame(view: WriterFrameViewModel): string {
  return `
    <main class="page">
      <section class="hero">
        <div class="hero-top">
          <div class="hero-title-group">
            <h1 class="hero-title">SPOT Writer</h1>
            <div class="version-note">Version ${escapeHtml(view.version)}</div>
          </div>
          <div class="hero-actions">
            <button
              type="button"
              id="hero-help-btn"
              class="hero-help-btn"
              aria-expanded="${view.helpExpanded ? "true" : "false"}"
            >
              Help
            </button>
          </div>
        </div>
      </section>

      <div class="stack">
        ${view.status}
        ${view.steps}
        ${view.helpCard}
        ${
          view.returnSource
            ? `<div class="return-actions"><button id="return-btn">Return to ${escapeHtml(view.returnSource)}</button></div>`
            : ""
        }
      </div>

      ${view.showFileInput ? '<input id="file-input" class="hidden-input" type="file" accept=".json,application/json" />' : ""}
    </main>
  `;
}
